import React, { Suspense } from "react";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import { useTranslation } from "react-i18next";
const Layout = ({ children }) => {
  const {t}=useTranslation();
  return (
    <>
      <Header />
      <main className="LayoutContainer">
        <Suspense
          fallback={
            <h1
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100vh",
              }}
            >
              {t('mainWords.loading')}
            </h1>
          }
        >
          {children}
        </Suspense>
      </main>
      <Footer />
    </>
  );
};

export default Layout;
